import { render, staticRenderFns } from "./ModalSubBukuBesarTahun.vue?vue&type=template&id=fdf79a1e"
import script from "./ModalSubBukuBesarTahun.vue?vue&type=script&lang=js"
export * from "./ModalSubBukuBesarTahun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports